import React from "react";

const periods = ["1주일", "1개월", "3개월", "6개월"];

const PeriodButton = ({ period, periodLabel, onClick }) => (
  <button
    type="button"
    className={periodLabel === period ? "active" : "inactive"}
    onClick={() => onClick(period)}>
    {period}
  </button>
);

const PeriodSelector = ({ changeDate, dateRange, getOrders, periodLabel, handlePeriodChange }) => {
  return (
    <div className="dateForm">
      <div className="periods">
        {periods.map((period) => (
          <PeriodButton
            key={period}
            period={period}
            periodLabel={periodLabel}
            onClick={handlePeriodChange}
          />
        ))}
      </div>
      <div className="dateRange">
        <input type="date" name="start" value={dateRange.start} onChange={changeDate} />
        <p>-</p>
        <input type="date" name="end" value={dateRange.end} onChange={changeDate} />
      </div>
      <button onClick={getOrders}>조회</button>
    </div>
  );
};

export default PeriodSelector;
